function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
var _templateObject, _templateObject2, _templateObject3;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.is-array.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useRef, useReducer, useLayoutEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import { Alert } from '@material-ui/lab';
export function useErrorNotifications() {
  var errorNotificationQueue = useRef(new ErrorNotificationQueue()).current;
  var ErrorNotifications = useRef(function ErrorNotifications() {
    var _useReducer = useReducer(function (s) {
        return s + 1;
      }, 0),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      forceRender = _useReducer2[1];
    useLayoutEffect(function () {
      return errorNotificationQueue.onUpdate(forceRender);
    }, []);
    return /*#__PURE__*/React.createElement(AlertsHolder, null, errorNotificationQueue.getAllReversed().map(function (errorInfo) {
      return /*#__PURE__*/React.createElement(AlertHolder, {
        show: errorInfo.show,
        "aria-hidden": !errorInfo.show,
        key: errorInfo.id
      }, /*#__PURE__*/React.createElement(Alert, {
        severity: "error",
        style: {
          width: '100%',
          height: '100%',
          pointerEvents: 'auto'
        }
      }, errorInfo.error.message));
    }));
  }).current;
  return {
    errorNotificationQueue: errorNotificationQueue,
    ErrorNotifications: ErrorNotifications
  };
}
var AlertsHolder = styled.div({
  position: 'fixed',
  top: 16,
  right: 0,
  zIndex: 99999,
  width: 316,
  overflow: 'hidden',
  // This is needed so the alerts holder doesn't block clicking anything beneath
  // the holder.  But - all the alerts within AlertsHolder need pointer-events
  // set to auto so you can't click through them
  pointerEvents: 'none'
});
var enter = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% {\n    transform: translate(316px);\n    height: 0;\n  }\n\n  50% {\n    transform: translate(316px);\n    height: 88px\n  }\n\n  100% {\n    transform: translate(0px);\n    height: 88px;\n  }\n"])));
var leave = keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  from {\n    transform: translate(0px);\n  }\n\n  to {\n    transform: translate(316px);\n  }\n"])));
var AlertHolder = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  animation: ", " 400ms ease-out;\n  animation-fill-mode: forwards;\n  width: 300px;\n  height: 88px;\n  padding-bottom: 8px;\n  overflow: hidden;\n"])), function (props) {
  return props.show ? enter : leave;
});
var ErrorNotificationQueue = /*#__PURE__*/function () {
  function ErrorNotificationQueue() {
    _classCallCheck(this, ErrorNotificationQueue);
    this.idCounter = 1;
    this.errors = [];
    this.callbacks = [];
  } // Each error needs a unique ID so we can pass it to the key prop in react.
  // Otherwise, the animations won't work properly because react will forget
  // which element is which.
  _createClass(ErrorNotificationQueue, [{
    key: "tellListenersQueueHasUpdated",
    value: function tellListenersQueueHasUpdated() {
      this.callbacks.forEach(function (callback) {
        return callback();
      });
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return this.errors;
    }
  }, {
    key: "getAllReversed",
    value: function getAllReversed() {
      // Need to shallow clone because reverse mutates
      // https://doesitmutate.xyz/reverse/
      return _toConsumableArray(this.errors).reverse();
    }
  }, {
    key: "onUpdate",
    value: function onUpdate(callback) {
      var _this = this;
      this.callbacks.push(callback);
      return function () {
        _this.callbacks.splice(_this.callbacks.indexOf(callback), 1);
      };
    }
  }, {
    key: "push",
    value: function push(error) {
      var _this2 = this;
      var id = (++this.idCounter).toString();
      this.errors.push({
        id: id,
        error: error,
        show: true
      });
      this.tellListenersQueueHasUpdated();

      // Hide the notification after 8 seconds.  It does't remove it from the
      // queue yet, because it needs time to animate out.  We have a separate
      // mechanism to clean up old notifications
      setTimeout(function () {
        var now = new Date();
        _this2.errors = _this2.errors.map(function (errorInfo) {
          if (errorInfo.id === id) {
            return _objectSpread(_objectSpread({}, errorInfo), {}, {
              show: false,
              timeHidden: new Date()
            });
          }
          return errorInfo;
        })
        // Clean-up any old errors that have finished animating out.   This is
        // to prevent memory leaks, otherwise the error list will grow
        // continuously.
        //
        // I tried doing this at the top of the push function but I was getting
        // very buggy behavior when adding more than 10 items and I don't know
        // why. Seems like it could be a babel or browser bug, because adding a
        // console.log fixed the issue, which was also making it difficult to
        // debug
        .filter(function (errorInfo) {
          if (errorInfo.timeHidden && Number(now) - Number(errorInfo.timeHidden) > 5000) {
            return false;
          }
          return true;
        });
        _this2.tellListenersQueueHasUpdated();
      }, 8000);
    }
  }]);
  return ErrorNotificationQueue;
}();